module.exports = __webpack_public_path__ + "static/media/tags.60f09067.svg";